// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"Sidebar_sidebar__u6syo","active":"Sidebar_active__XYpke","serverTitle":"Sidebar_serverTitle__SSmFa","disabled":"Sidebar_disabled__VlJ6N"};